<template>
  <div class="equipment-list">
    <div class="btns">
      <el-button type="primary" @click="addShuiBeng('Pump', '添加水泵')">添加水泵</el-button>
      <el-button type="primary" @click="addShuiBeng('Fan', '添加风机')">添加风机</el-button>
    </div>
    <div class="list">
      <div class="list-item" v-for="(item, i) in dataList" :key="i">
        <el-card :body-style="{ padding: '16px' }">
          <div class="card-title">
            <div class="title-text">
              {{ item.sewageBlockName }}
            </div>
            <div class="btn-container">
              <el-button size="small" type="primary" :icon="Edit" circle @click="edit(item, i)"> </el-button>

              <el-popconfirm title="是否确认删除设备?" @confirm="dele(item)">
                <template #reference>
                  <el-button size="small" type="danger" :icon="Delete" circle></el-button>
                </template>
              </el-popconfirm>
            </div>
          </div>
          <div class="card-content">
            <div class="left-content">
              <el-image :src="item.image" style="width: 120px; height: 120px"></el-image>
              <div class="info-container">
                <div class="info-item">
                  <div class="info-name">当前总功率：</div>
                  <div class="info-value">{{ item.power }}W</div>
                </div>
                <div class="info-item">
                  <div class="info-name">今日用电量：</div>
                  <div class="info-value">{{ item.dayElectric }}KW·h</div>
                </div>
                <div class="info-item">
                  <div class="info-name">总用电量：</div>
                  <div class="info-value">{{ item.totalElectric }}KW·h</div>
                </div>
              </div>
            </div>
            <div class="right-content">
              <div class="base-info info-item">
                <div class="info-title">基本信息</div>
                <div class="section time">
                  <div class="label">正常运行时间:</div>
                  <div class="value">{{ item.normalRunHours }}</div>
                </div>
                <div class="wrap">
                  <div class="section">
                    <div class="label">开关信号:</div>
                    <div class="value">
                      <el-switch v-model="item.switchSignal" disabled active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                  </div>
                  <div class="section">
                    <div class="label">运行状态:</div>
                    <div class="value">
                      <el-image :src="item.statusImage" style="width: 20px; height: 20px"></el-image>
                    </div>
                  </div>
                </div>
              </div>
              <div class="warn-info info-item" v-if="item.warnLogList && item.warnLogList.length > 0">
                <div class="info-title">告警</div>
                <div class="warn-list">
                  <div class="section" v-for="(warn, index) in item.warnLogList" :key="index" :class="{ 'animate-up': animateUp }">
                    <div class="label">{{ warn.equipmentName }}:</div>
                    <div class="value">{{ warn.triggerRule }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <shuibengConfigDialog ref="ShuibengConfigDialog" @submit="getDataList" :dialogTitle="dialogTitle" :type="type" :list-data="listData"></shuibengConfigDialog>
  </div>
</template>

<script setup>
import { ref, onMounted, inject, computed, watch } from "vue";
import { getSewageDistributionRooms, getKanbanDataApiV2, deleteSewageDistributionRoom } from "@/api/modules/project";
import { Edit, Delete } from "@element-plus/icons-vue";
import { ElMessage, ElLoading } from "element-plus";
import XEUtils from "xe-utils";
import shuibengConfigDialog from "./shuibeng-config-dialog.vue";
const ShuibengConfigDialog = ref(null);

const receiveTemplateId = inject("templateId");
const receiveProjectModuleId = inject("projectModuleId"); // 默认值为21
const dataList = computed(() => {
  let list = [];
  listData.value.forEach((item) => {
    item.list.forEach((item1) => {
      list.push(item1);
    });
  });
  return list;
});
const listData = ref([
  {
    name: "水泵",
    list: [],
    type: "Pump",
  },
  { name: "风机", type: "Fan", list: [] },
]);

let dialogTitle = ref("添加水泵");
let type = ref("Pump");
// 添加设备
const addShuiBeng = (key, title) => {
  dialogTitle.value = title;
  type.value = key;
  ShuibengConfigDialog.value.openDialog();
};
// 编辑设备
const edit = (item, i) => {
  dialogTitle.value = item.type == "Pump" ? "编辑水泵" : "编辑风机";
  type.value = item.type;

  ShuibengConfigDialog.value.openDialog(item.blockNameKey, item.blockId);
};
// 删除设备
const dele = (item) => {
  let params = {
    moduleId: receiveProjectModuleId.value,
    blockName: item.blockNameKey,
  };
  deleteSewageDistributionRoom(params).then((res) => {
    if (res.data.code == 200) {
      getDataList();
    }
  });
};

const getDataList = () => {
  const loading = ElLoading.service({ lock: true, text: "Loading", background: "rgba(0, 0, 0, 0.7)" });
  let params = { moduleId: receiveProjectModuleId.value, templateId: receiveTemplateId.value, blockName: "sewageDistributionRoom" };

  getSewageDistributionRooms(params).then((roomsRes) => {
    if (roomsRes.data.code == 200) {
      loading.close();

      if (!roomsRes.data.data)
        return (listData.value = [
          {
            name: "水泵",
            list: [],
            type: "Pump",
          },
          { name: "风机", type: "Fan", list: [] },
        ]);
      let requestArray = [];
      let PumpNameList = [];
      let FanNameList = [];
      for (const key in roomsRes.data.data) {
        if (Object.prototype.hasOwnProperty.call(roomsRes.data.data, key)) {
          const element = roomsRes.data.data[key];
          if (element.includes("Pump")) {
            PumpNameList.push({
              blockId: key,
              blockNameKey: element,
            });
          } else {
            FanNameList.push({
              blockId: key,
              blockNameKey: element,
            });
          }
          requestArray.push(getKanbanDataApiV2({ ...params, blockName: element }));
        }
      }

      Promise.all(requestArray).then((res) => {
        let PumpDataList = [];
        let FanDataList = [];
        res.forEach((item, index) => {
          if (item.data.code == 200) {
            let data = item.data.data;
            PumpNameList.forEach((pumpItem) => {
              console.log("PumpNameList", pumpItem);
              if (!data[pumpItem.blockNameKey]) return;
              let obj = {
                type: "Pump",
                blockNameKey: pumpItem.blockNameKey,
                blockId: pumpItem.blockId,
                image: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/icon-pump.png",
                statusImage: `https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/icon-pump-status-${
                  data[pumpItem.blockNameKey].runningState > data[pumpItem.blockNameKey].normalPower ? 1 : 0
                }.png`,
              };
              if (!XEUtils.isEmpty(data[pumpItem.blockNameKey].warnLogList)) {
                data[pumpItem.blockNameKey].warnLogList = data[pumpItem.blockNameKey].warnLogList.filter((item) => item.level != 5);
              }
              PumpDataList.push({ ...data[pumpItem.blockNameKey], ...obj });
            });
            FanNameList.forEach((fanItem) => {
              if (!data[fanItem.blockNameKey]) return;
              let obj = {
                type: "Fan",
                blockNameKey: fanItem.blockNameKey,
                blockId: fanItem.blockId,
                image: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/icon-fan.png",
                statusImage: `https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/icon-fan-status-${
                  data[fanItem.blockNameKey].runningState > data[fanItem.blockNameKey].normalPower ? 1 : 0
                }.png`,
              };
              if (!XEUtils.isEmpty(data[fanItem.blockNameKey].warnLogList)) {
                data[fanItem.blockNameKey].warnLogList = data[fanItem.blockNameKey].warnLogList.filter((item) => item.level != 5);
              }

              FanDataList.push({ ...data[fanItem.blockNameKey], ...obj });
            });
          }
        });
        listData.value[0].list = PumpDataList;
        listData.value[1].list = FanDataList;
      });
    }
  });
};
let animateUp = ref(false);
const scrollAnimate = function () {
  animateUp.value = true;
  dataList.value.map((item) => {
    setTimeout(() => {
      if (item.warnLogList && item.warnLogList.length > 0) {
        item.warnLogList.push(item.warnLogList[0]);
        item.warnLogList.shift();
        animateUp.value = false;
      }
    }, 500);
  });
};
const lunbo = function () {
  setInterval(scrollAnimate, 4000);
};
watch(
  () => receiveProjectModuleId.value,
  (val) => {
    if (val) {
      getDataList();
    }
  }
);
onMounted(() => {
  lunbo();

  getDataList();
});
</script>

<style lang="scss" scoped>
.equipment-list {
  width: 100%;
  .btns {
    text-align: right;
    padding: 10px 20px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 10px;
    .list-item {
      width: calc(50% - 20px);
      box-sizing: border-box;
      .card-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .title-text {
          font-weight: 600;
          font-size: 14px;
          color: #333333;
        }
        .btn-container {
          display: flex;
          gap: 10px;
        }
      }
      .card-content {
        display: flex;
        .left-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          .info-container {
            margin-top: 20px;
            display: flex;
            gap: 20px;
            .info-item {
              display: flex;
              flex-direction: column;

              .info-name {
                font-size: 12px;
                line-height: 12px;
                color: #666666;
              }
              .info-value {
                margin-top: 8px;
                font-size: 16px;
                line-height: 16px;
                color: #333333;
              }
            }
          }
        }
        .right-content {
          display: flex;
          flex-direction: column;
          gap: 12px;
          flex: 1;
          min-width: 0;

          .info-item {
            padding: 16px 10px;
            border-radius: 4px;
            .info-title {
              font-weight: 600;
              font-size: 14px;
              color: #333333;
              line-height: 14px;
              position: relative;
              &::before {
                content: "";
                position: absolute;
                width: 3px;
                height: 14px;
                top: 0px;
                left: -10px;
                background: #165dff;
              }
            }
          }
          .base-info {
            background: rgba(22, 93, 255, 0.1);
            .info-title {
              &::before {
                background: #165dff;
              }
            }
            .wrap {
              display: flex;
              justify-content: space-between;
            }
            .section.time {
              margin: 12px 0 8px;
            }
            .section {
              display: flex;
              align-items: center;
              gap: 10px;
              .label {
                font-size: 12px;
                color: #666666;
                line-height: 12px;
              }
              .value {
                font-size: 16px;
                color: #333333;
                line-height: 16px;
              }
            }
          }
          .warn-info {
            overflow: hidden;

            background: rgba(254, 234, 234, 0.4);
            .info-title {
              &::before {
                background: #ef2121;
              }
            }
            .warn-list {
              margin-top: 8px;
              height: 36px;
              overflow: hidden;
              .section {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #333333;
                line-height: 14px;
                margin-bottom: 8px;
                width: 100%;

                .value {
                  flex: 1;
                  min-width: 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .animate-up {
              transition: all 0.5s ease-in-out;
              transform: translateY(-40px);
            }
          }
        }
      }
    }
  }
}
</style>
